import React, { useEffect, useState } from "react";
import logo from "../components/assets/logo.svg";
import cbn from "../components/assets/cbn.svg";
import { useNavigate } from "react-router-dom";
import InsuranceFaqModal from "../components/FAQ-insurance";
import installimg from "../components/assets/installment.svg"
import card from "../components/assets/card.svg"
import arrowleft from "../components/assets/arrow-left.svg"
import { getMerchantDetails } from "../services/interface/InterfaceService";
import { Fire } from "../utils/Fire";
import { getAccessToken, setAccessToken } from "../utils/config";
import loader from "../components/anime/loading.json";
import Lottie from "react-lottie";
import config from "../config.json";

const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: loader,
  color: "red",
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const HomePage = () => {
  // const location = useLocation();
  const [IsCard, setIsCard] = useState(false);
  const [isInstallment, setIsInstallment] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    // Insurance flow should start on the instalment screen (Home.jsx)
    console.log("appName", config.appName)
    if (config.appName === "insurance") {
      navigate("/gateway/installment", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    setAccessToken(config.apiSecret)
  }, [])

  const GoToPayment = (type) => {
    if (type === "card" && IsCard) {
      navigate("/gateway/card")
    } else if (type === "card" && !IsCard) {
      Fire("warning", "Merchant do not accept card payment")
    } else if (type === "installment" && isInstallment) {
      navigate("/gateway/installment")
    } else {
      Fire("warning", "Merchant do not accept instalment payment")
    }
  }


  useEffect(() => {
    const fetchMerchantAndInsuranceDetails = async () => {
      try {
        setLoading(true)
        const merchantResponse = await getMerchantDetails();
        if (merchantResponse) {
          const source = merchantResponse?.paymentSource;
          setIsCard(source.includes("Card"));
          setIsInstallment(source.includes("Instalment"))
          setLoading(false)
        } else {
          setLoading(false)
          setError(true)
        }

      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false)
        setError(true)
      }
    }

    if (getAccessToken() != null) {
      fetchMerchantAndInsuranceDetails();
    } else {
      Fire("info", "Connecting, a moment")
      setLoading(false)
      setError(true)
    }
  }, []);

  // useEffect(() => {
  //   //console.log("error", error)
  // }, [])



  return (
    <div className="flex max-h-screen items-center justify-center bg-transparent bg-gray-600 mt-[unselt] md:mt-20 ">
      <div className="rounded-lg bg-white md:w-[700px] w-full  border-[1px] border-gray-200 shadow-sm px-5 py-5 relative pb-10 mx-auto text-center h-full">
        <div className="flex flex-col pt-5 items-center text-center justify-center md:w-[75%] w-full md:mx-auto md:my-auto md:px-10">
          <div className="self-center items-center flex flex-col gap-1 mb-7">
            <img src={logo} alt="logo" />
            <h1 className={`${(!isInstallment || !IsCard) && "hidden"} text-xl`}>Premium<span className="text-red-600">Trust</span> Bank</h1>
          </div>
          {
            loading ? (<div>
              <Lottie
                options={defaultOptions2}
                height={100}
                width={100}
              />
            </div>) : error ? <>
              <h1 className={`${(isInstallment && IsCard) && "hidden"} text-xl`}>Premium<span className="text-red-600">Trust</span> Bank</h1>
              <div className="mt-10">
                <div>
                  <h1>We are sorry, an error occured</h1>
                  <p>Please try again shortly</p>
                </div>
              </div>
            </> :
              <div>
                <h1 className={`${(isInstallment && IsCard) && "hidden"} text-xl`}>Premium<span className="text-red-600">Trust</span> Bank</h1>
                <div className=" flex md:w-[100%] w-full relative justify-center flex-row">
                  <div>
                    <h2 className=" text-xl font-bold mb-5 capitalize">{(isInstallment && IsCard) && "How would you like to pay?"}</h2>
                  </div>
                </div>
                <div className={`flex-1 flex flex-col gap-5 w-full mt-10 mb-28`} >
                  <button onClick={() => GoToPayment("installment")} className={`bg-transparent border-2 border-gray-200 py-3 px-5  ${!isInstallment ? "hidden" : "flex"}  justify-between items-center rounded-md active:scale-95 transition-transform ease-in-out duration-300`}>
                    <div className="flex items-center gap-6">
                      <div className="border-2 rounded-full p-2 border-black">
                        <img className="w-6 h-6" src={installimg} alt="installment" />
                      </div>
                      <div className="flex flex-col justify-start">
                        <h1 className="text-left font-extrabold">Pay in instalments</h1>
                        <p className="font-light text-sm">Enjoy flexible repayment </p>
                      </div>
                    </div>
                    <div>
                      <img src={arrowleft} alt="arrowleft" />
                    </div>
                  </button>
                  <button onClick={() => GoToPayment("card")} className={`bg-transparent border-2 border-gray-200 py-3 px-5  ${!IsCard ? "hidden" : "flex"}  justify-between items-center rounded-md active:scale-95 transition-transform ease-in-out duration-300`}>
                    <div className="flex items-center gap-6">
                      <div className="border-2 rounded-full p-2 border-black">
                        <img className="w-6 h-6" src={card} alt="installment" />
                      </div>
                      <div className="flex flex-col justify-start">
                        <h1 className="text-left font-extrabold">Pay with card</h1>
                        <p className="font-light text-sm">Pay securely with debit or credit card </p>
                      </div>
                    </div>
                    <div>
                      <img src={arrowleft} alt="arrowleft" />
                    </div>
                  </button>
                </div>
                {
                  (!IsCard && !isInstallment) && <div className="-mt-10">
                    <div>
                      <h1>This merchant is not accepting payment yet</h1>
                      <p>Contact merchant</p>
                    </div>
                  </div>
                }
              </div>
          }

          <div className="text-center mt-20">
            <p className="text-[#001F54] text-sm">Powered by</p>
            <div className="flex items-center gap-1 mt-1">
              <img className="w-4" src={logo} alt="cbn" />
              <p className="text-[#001F54] text-sm font-semibold">
                Premium<span className="text-red-500">Trust</span>Bank
              </p>
            </div>
          </div>
          <InsuranceFaqModal isOpen={false} />
          <div className="flex w-full justify-center text-center items-center gap-2 mt-12 font-medium">
            <img src={cbn} alt="cbn" />
            <p className="text-[#001F54] md:text-md text-sm">
              Licensed by the Central Bank of Nigeria
            </p>
          </div>
        </div>
      </div>
    </div>

  );
};

export default HomePage;
